import { getSplitIOKey, SplitIOApiKeyConfig } from './SplitIOApiKeyConfig';
import { SplitIOFacade } from './SplitIOFacade';

export async function isFeatureEnabled(
    ffName: string,
    apiKeyConfig: SplitIOApiKeyConfig,
    additionalSplitAttributes?: {
        [splitAttribute: string]: boolean | string | number;
    },
    key?: string,
): Promise<boolean | null> {
    if (typeof window === 'undefined') {
        return null;
    }

    if (process.env.NODE_ENV === 'test') {
        return false;
    }
    const apiKey = getSplitIOKey(window.location.host, apiKeyConfig);
    const splitAttributes = {
        guest_id: window.__SERVER_DATA__?.guest_id,
        user_id: window.__SERVER_DATA__?.user?.publicId,
        ...additionalSplitAttributes,
    };

    const featureEnabled = await SplitIOFacade.isFeatureEnabled(
        apiKey,
        apiKeyConfig.workspace,
        ffName,
        splitAttributes,
        key,
    );

    return featureEnabled;
}
